import type { CalculationResponseType } from '../Connection/types';

export class Calculation {
    private _innerId: string;
    private _calculation: CalculationResponseType | null = null;

    public constructor() {
        this._innerId = Math.random().toString(36).substring(7);
    }

    getId() {
        if (typeof this._calculation?.id === 'undefined') {
            throw new Error('Calculation.getId: id is not set');
        }
        return this._calculation?.id;
    }

    exists(): boolean {
        return this._calculation !== null && this._calculation?.id !== undefined;
    }

    public set(calculation: CalculationResponseType): this {
        this._calculation = calculation;
        return this;
    }

    public get(): CalculationResponseType | null {
        return this._calculation;
    }

    public getDay(): string {
        return this._calculation?.day ?? '';
    }
}
